/*
 * @Author: chenhe ch10@meitu.com
 * @Date: 2025-08-25 14:56:18
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-08-26 18:34:32
 * @FilePath: /roboneo-web/packages/roboneo-sdk/src/common/utils/localStorageUtil.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
type LocalStorageItemKey =
  | 'access_token'
  | 'uid'
  | 'isSupportWebp'
  | 'lang'
  | 'popupData'
  | 'surverPopupUid'
  | 'RoboneoDownloadHasWatermark'
  | 'roboneo_inserted_resources_v3'
  | 'workflow_pending_execution_nodes'
  | 'roboneo_workflow_cost_dont_remind'
  | 'roboneo_asset_library_last_tab'
  | 'agentInfoList'
  | 'seedance_v2_agreement_accepted'
  | 'roboneoHappyHorseGuideCloseTime';

function setItem(key: LocalStorageItemKey, value: string): void {
  // eslint-disable-next-line ban/ban
  localStorage.setItem(key, value);
}

function getItem(key: LocalStorageItemKey): string | null {
  // eslint-disable-next-line ban/ban
  return localStorage.getItem(key);
}

function removeItem(key: LocalStorageItemKey): void {
  // eslint-disable-next-line ban/ban
  return localStorage.removeItem(key);
}

const localStorageUtil = {
  setItem,
  getItem,
  removeItem,
};

export default localStorageUtil;

type LocalStorageItem = (
  | {
    key: 'access_token';
    value: string;
  }
  | {
    key: 'uid';
    value: string;
  }
  | {
    // vmake 登录sdk默认access_token
    key: 'vmake-auth-store';
    value: string;
  }
  | {
    // 订阅弹框
    key: 'meidou_trade_ids';
    value: string;
  }
) & {
  expiresAt?: number;
};

type Key = 'meidou_trade_ids';

export function setLocalStorageItem(item: LocalStorageItem) {
  // eslint-disable-next-line ban/ban
  localStorage.setItem(item.key, JSON.stringify(item));
}

export function getLocalStorageItem(key: Key): LocalStorageItem | null {
  // eslint-disable-next-line ban/ban
  const str = localStorage.getItem(key);
  if (str) {
    const item = JSON.parse(str);
    if (item && item.expiresAt && new Date().getTime() > item.expiresAt) {
      // eslint-disable-next-line ban/ban
      localStorage.removeItem(key);
      return null;
    }
    return item as LocalStorageItem;
  }
  return null;
}
